import { LOAD_SIGN_UP2_FORM } from '../constants';

const loadFormDefaults = data => ({ type: LOAD_SIGN_UP2_FORM, data });

export default loadFormDefaults;
